/** Map consultant navigation to views available in the client portal. */
export function portalPath(path: string): string {
  if (path === '/portal' || path.startsWith('/portal/')) return path;
  const [pathname, query] = path.split('?');
  const suffix = query ? `?${query}` : '';
  if (/^\/lab-reports(?:\/[^/]+)?$/.test(pathname)) return `/portal${pathname}${suffix}`;
  if (/^\/(actions|notifications|profile|whats-new)$/.test(pathname)) return `/portal${pathname}${suffix}`;
  if (pathname.startsWith('/facilities')) return '/portal/facilities';
  if (pathname.startsWith('/inspections')) return '/portal/inspections';
  return '/portal';
}
